import type { PathDef, SceneData } from '../types/scene'

export function activePathsOf(scene: SceneData | undefined): PathDef[] {
  return scene?.paths ?? []
}

export function addPathToScene(scene: SceneData | undefined, path: PathDef) {
  if (!scene) return
  scene.paths = [...(scene.paths ?? []), path]
}

export function removePathFromScene(scene: SceneData | undefined, id: string) {
  if (!scene) return
  scene.paths = (scene.paths ?? []).filter(p => p.id !== id)
  // 解除所有引用该路径的对象绑定
  scene.objects = scene.objects.map(obj =>
    obj.pathId === id ? { ...obj, pathId: null } : obj
  )
}

export function updatePathInScene(scene: SceneData | undefined, id: string, patch: Partial<PathDef>) {
  if (!scene) return
  const idx = (scene.paths ?? []).findIndex(p => p.id === id)
  if (idx < 0) return
  scene.paths![idx] = { ...scene.paths![idx], ...patch }
}

